import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../components/buttons/Button";
import Content from "../../../components/Content";
import InputField from "../../../components/Inputs/InputField";
import * as serviceApi from "../../../hooks/useServiceData";
import { useSnackbar } from "notistack";
import Check from "../../../components/Inputs/Check";

export const MaterialEditView = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [edited, setEdited] = useState(false);

  const materialParam = useParams();
  const materialId = materialParam.id;

  const [name, setName] = useState("");
  const [ownerId, setOwnerId] = useState("");
  const [cost, setCost] = useState("");
  const [isActive, setIsActive] = useState(true);

  const { data } = serviceApi.GetMaterial(materialId);

  const { mutate } = serviceApi.UpdateMaterial();

  useEffect(() => {
    if (data?.data) {
      setName(data?.data.name);
      setOwnerId(data?.data.owner_id);
      setCost(data?.data.cost);
      setIsActive(data?.data.isActive === 1 ? true : false);
    }
  }, [data]);

  const updateMaterial = () => {
    let _material = {};

    _material.materialId = data?.data.id;
    _material.name = name;
    _material.owner_id = ownerId;
    _material.cost = cost;
    _material.isActive = isActive;

    mutate(_material, {
      onSuccess: () => {
        enqueueSnackbar("Material uppdaterad.", {
          variant: "success",
        });
        navigate(`/registry/material/details/${materialId}`);
      },
      onError: (error) => {
        enqueueSnackbar("Material kunde inte uppdateras.", {
          variant: "success",
        });
        console.log("ERROR UPDATING MATERIAL: ", error);
      },
    });
  };

  return (
    <>
      <Content title={`${data?.data.name}`}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            updateMaterial();
          }}
          className="container"
          style={{ width: "100%" }}
        >
          <div className="form-grid-auto">
            <InputField
              required
              label={"Materialets namn"}
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setEdited(true);
              }}
            />
            <InputField
              required
              label={"Materialets id"}
              value={ownerId}
              onChange={(e) => {
                setOwnerId(e.target.value);
                setEdited(true);
              }}
            />
            <InputField
              required
              type="number"
              label={"Materialets kostnad"}
              value={cost}
              onChange={(e) => {
                setCost(e.target.value);
                setEdited(true);
              }}
            />
          </div>

          <Check
            color="success"
            label="Aktiv"
            checked={isActive}
            onChange={(e) => {
              setIsActive(e.target.checked);
              setEdited(true);
            }}
          />

          <div className="rightAlign-button-container">
            <Button
              className={edited ? "button-pulse" : undefined}
              disabled={!edited}
              type="submit"
              color="success"
            >
              Spara
            </Button>
          </div>
        </form>
      </Content>
    </>
  );
};
